import Image from 'next/image';
import React from 'react';
import { useTranslation } from 'react-i18next';

import brain from '@/assets/images/brain-doesnt-know.png';
import heart from '@/assets/images/heart-muscles.png';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ContentContainer } from '@/components/layout';
import { Text } from '@/components/typography';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
import { mergeClasses } from '@/utils/style';

interface FaqIntroProps {
	className?: string;
	text?: string | React.JSX.Element;
	link?: string;
	title?: string;
	cta?: string;
	anchorKey?: string;
}

export function FaqIntro({
	className,
	text,
	link,
	title,
	cta,
	anchorKey = 'core.faqIntro.title',
}: FaqIntroProps): React.JSX.Element {
	const { t } = useTranslation('core');

	return (
		<ContentContainer>
			<div
				className={mergeClasses(
					'-mb-10 flex flex-row flex-wrap items-center justify-center md:flex-nowrap lg:-my-20',
					className
				)}
			>
				<div className="p-4 md:order-2 md:w-1/2">
					<SectionHeadline className="mb-5 whitespace-nowrap" anchorKey={anchorKey}>
						{title || t('faqIntro.title')}
					</SectionHeadline>

					<Text variant="p2" className="mb-10 text-center text-gray-800 lg:mb-12">
						{text || t('faqIntro.text')}
					</Text>

					<Button
						variant="primary"
						testId="faqIntroShowFaq"
						analyticsParam="faqIntroShowFaq"
						to={link || LINKS().faq}
						size="lg"
						align="center"
					>
						{cta || t('faqIntro.cta')}
					</Button>
				</div>

				<div className="-mr-8 w-1/2 pt-10 md:order-1 md:m-0 md:py-4 md:pt-0 md:pr-10">
					<Image src={brain} alt="" width={384} />
				</div>

				<div className="w-1/2 pr-4 md:order-3 md:py-4 md:pl-10">
					<Image src={heart} alt="" width={360} />
				</div>
			</div>
		</ContentContainer>
	);
}
